import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { RetargetingProvider, useRetargetingStore } from '../store';

const RetargetingForm = ({ total }) => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset } } = useRetargetingStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleSidebarClose = useCallback(() => {
    history.push("/path/retargeting");
    reset()
  }, [reset])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit({
        ...payload,
        sort: payload.id ? payload.sort : total,
      })
      handleSidebarClose()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Retargeting Placement ${message}.`)
    } catch {
      handleError('Error', 'Retargeting Placement was not saved.')
    }
  }, [handleSubmit, handleSidebarClose, total, handleSuccess, handleError]);

  if (!item) {
    return null
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleSidebarClose() }}
    title={item.id ? 'Edit Retargeting Placement' : 'Add Retargeting Placement'}>
    <Helmet title='Retargeting Placement' />
    <Form data={item} handleSubmit={handleSubmitAndClose} />
  </DefaultSheet>
};

export default function RetargetingFormLayout() {
  const { collections: { items } } = useRetargetingStore()
  return <RetargetingProvider>
    <RetargetingForm total={items?.length} />
  </RetargetingProvider>
}
